import React, { useEffect, useState } from 'react'
import MySpiner from '../../../UI/spiner/MySpiner'
import { getUsersInDepartmentAPI } from '../../../../api/workPlace/workPlaceAPI'
import WorkLinePlaceGroupUserForm from './WorkLinePlaceGroupUserForm'
import ClearIcon from '@mui/icons-material/Clear';
import { deleteObjInArrayForm } from '../../../../helpers/form/FormHelper';
import MyButton from '../../../UI/form/MyButton';
import WorkLinePlaceGroupAdd from './WorkLinePlaceGroupAdd';
import WorkLinePlaceUserList from '../WorkLinePlaceUserList';

const WorkLinePlaceGroupForm = ({ departmentType, departmentId, workLinePlaceId }) => {

    const [users, setUsers] = useState([])
    const [usersWork, setUsersWork] = useState([])

    console.log('usersWork', usersWork)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getUsersInDepartment()
    }, [departmentType, departmentId])

    const getUsersInDepartment = () => {
        setLoading(true)
        getUsersInDepartmentAPI({ departmentType, departmentId }).then(data => {
            setUsers(data)
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        }) 
    }

    const deleteUser = (userId) => {
        deleteObjInArrayForm(setUsersWork, userId)
    }

  return (
    <div className='workLinePlaceGroup'>
        {/* <div className='workLinePlaceGroup__userList'> */}
            <WorkLinePlaceUserList 
                users={usersWork}
                deleteUser={deleteUser}
                isCanDelete={true}
            />
            {/* {
                usersWork && usersWork.length > 0 ?
                    usersWork.map((user, item) => {
                        return (
                            <div>
                                <p>{item + 1}</p>
                                <p>{user.surname} {user.name}</p>
                                <p 
                                    onClick={e => deleteUser(user.id)}
                                    className='workLinePlaceGroup__userList-delete-ico'
                                >
                                    <ClearIcon />
                                </p>
                            </div>
                        )
                    })
                : ''
            } */}
        {/* </div> */}

        {
            usersWork && usersWork.length > 0 ?
                <WorkLinePlaceGroupAdd
                    usersWork={usersWork}
                    workLinePlaceId={workLinePlaceId}
                />
            : ''
        }

        {
            loading ?
                <MySpiner />
            :
                <WorkLinePlaceGroupUserForm 
                    users={users}
                    usersWork={usersWork}
                    setUsersWork={setUsersWork}
                />
        }        

    </div>
  )
}

export default WorkLinePlaceGroupForm